import { render, staticRenderFns } from "./SignupStore.vue?vue&type=template&id=318986b3&"
import script from "./SignupStore.vue?vue&type=script&lang=js&"
export * from "./SignupStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports